/** Media queries collection which targets different devices capabilities */
export const device = {
  /** Targets devices that can hover an element */
  canHover: '@media (hover: hover)',
  /** Targets devices that cannot hover an element */
  cannotHover: '@media (hover: none)',
  /** Targets devices with a touch screen as a main input mechanism */
  hasTouchscreen: '@media (pointer: coarse)',
  /** Targets devices with a mouse/stylys as a main input mechanism */
  hasMouse: '@media (pointer: fine)',
};
